<template>
  <!-- <div v-if="additionalMaterialTypeCopy"> -->
  <b-modal :id="modalId" title="Customize Email" v-model="showModal" hide-footer @hide="hideModal">

    <div>
      <b-alert show variant="info">Review the message below and replace any necessary information (e.g. course and
        SLN)</b-alert>
      <b-alert :show="studentOpportunityCopy && !studentOpportunity.scheduleLineNumber" variant="danger">
        <strong>Warning:</strong> This student opportunity does not have a class selected. To provide a course override
        request, a class needs to be selected. Please selected the relevant class before approving.
      </b-alert>
      <b-form @submit.prevent="submit()" class="form-horizontal">
        <b-form-group label="Email Message" label-class="font-weight-bold"
          :class="{ 'invalid-group': $v.form.message.$error }">
          <vue-editor v-model="form.message" id="messageEditor"
            :class="{ 'is-invalid': $v.form.message.$error }"></vue-editor>
          <span class="span-feedback invalid-feedback" v-if="$v.form.message.$error">You must provide a message.</span>
        </b-form-group>

        <b-btn variant="primary" type="submit" class="ml-2 pull-right">Set Status and Send Email</b-btn>
        <b-btn variant="secondary" @click="hideModal()" class="ml-2 pull-right">Cancel</b-btn>
        <b-btn variant="secondary" @click="reset()" class="ml-2 pull-right">Reset</b-btn>
      </b-form>
    </div>
  </b-modal>
  <!-- </div> -->
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

var htmlEncode = require("js-htmlencode").htmlEncode;

export default {
  data() {
    return {
      // make a copy to avoid mutating props
      additionalMaterialTypeCopy: {},
      studentOpportunityAdditionalMaterialCopy: null,
      studentOpportunityCopy: null,
      form: {
        email: "",
        name: "",
        message: ""
      }
    };
  },

  components: { VueEditor },

  props: {
    additionalMaterialType: {
      type: Object,
      required: true
    },
    studentOpportunity: {
      required: false,
      type: Object,
      default: function () {
        return { studentOpportunityId: 0 };
      }
    },
    studentOpportunityAdditionalMaterial: {
      required: false,
      type: Object
    },
    studentOpportunityAdditionalMaterialId: {
      required: false,
      type: Number,
      default: 0
    },
    show: {
      required: false,
      type: Boolean,
      default: false
    },
    message: {
      required: false,
      type: String,
      default: ""
    }
  },

  validations() {
    return {
      form: {
        name: {
          required
        },
        email: {
          required
        },
        message: {
          required
        }
      }
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    showModal: {
      get() {
        return this.show;
      },
      set(show) {
        return show;
      }
    },
    modalId() {
      return "email-modal-" + this.studentOpportunityAdditionalMaterialId;
    }
  },

  methods: {
    reset: function () {
      this.transformMessage();
    },
    hideModal: function () {
      this.$emit("hideModal", { id: this.modalId });
    },
    submit() {
      this.$emit("complete", {
        message: htmlEncode(this.form.message),
        course: this.form.course,
        sln: this.form.sln
      });
      this.hideModal();
    },
    transformMessage() {
      var that = this;
      var res = this.message.replace(
        /{TranslationalTeam}|{Semester}|{Class}|{Instructor}|{Name}|{Student}/g,
        key => {
          switch (key) {
            case "{TranslationalTeam}":
              if (that.studentOpportunityCopy.opportunity.translationalTeam) {
                return that.studentOpportunityCopy.opportunity.translationalTeam
                  .name
                  ? that.studentOpportunityCopy.opportunity.translationalTeam
                    .name
                  : "";
              }
              return "";
            case "{Student}":
              return (
                that.studentOpportunityCopy.student.firstName +
                " " +
                that.studentOpportunityCopy.student.lastName
              );
            case "{Name}":
              return that.form.name;
            case "{Semester}":
              return that.studentOpportunityCopy.opportunity.term.description;
            case "{Instructor}":
              if (that.studentOpportunityCopy.class) {
                return (
                  that.studentOpportunityCopy.class.asurite.firstName +
                  " " +
                  that.studentOpportunityCopy.class.asurite.lastName +
                  " " +
                  that.studentOpportunityCopy.class.asurite.email
                );
              } else {
                return "";
              }
            case "{Class}":
              return that.studentOpportunityCopy.scheduleLineNumber &&
                that.studentOpportunityCopy.catalogNumber &&
                that.studentOpportunityCopy.scheduleLineNumber
                ? that.studentOpportunityCopy.subjectCode +
                " " +
                that.studentOpportunityCopy.catalogNumber.trim() +
                " - " +
                that.studentOpportunityCopy.scheduleLineNumber
                : "{Class}";
          }
        }
      );
      that.form.message = res;
    }
  },

  watch: {
    additionalMaterialType: function () {
      this.additionalMaterialTypeCopy = this.additionalMaterialType;
    },

    studentOpportunity: {
      handler(val) {
        this.studentOpportunityCopy = this.studentOpportunity;
        this.transformMessage();
      },
      deep: true
    },
    user: function () {
      this.form.email = this.user.email;
      this.form.name = this.user.firstName + " " + this.user.lastName;
    },
    message: function () {
      this.transformMessage();
    }
  },

  created() {
    this.studentOpportunityCopy = this.studentOpportunity;
    this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial;
    this.additionalMaterialTypeCopy = this.additionalMaterialType;

    if (this.user) {
      this.form.email = this.user.email;
      this.form.name = this.user.firstName + " " + this.user.lastName;
      if (
        this.studentOpportunity.scheduleLineNumber &&
        this.studentOpportunity.catalogNumber &&
        this.studentOpportunity.scheduleLineNumber
      ) {
        this.form.subjectCode = this.studentOpportunity.subjectCode;
        this.form.catalogNumber = this.studentOpportunity.catalogNumber.trim();
        this.form.scheduleLineNumber = this.studentOpportunity.scheduleLineNumber;
      }
      this.transformMessage();
    }
  }
};
</script>

<style scoped>
h5 {
  font-size: 0.9em;
}

label {
  font-weight: bold;
}

.form-control-file {
  width: 70%;
}

.flex-float-right {
  margin-left: auto;
}

.invalid-label {
  color: #dc3545;
}

.alert-success {
  width: 100%;
}

.accordion-control {
  width: 100%;
  text-align: center;
  background-color: #e9e9e9;
  border: 1px solid #d1d2d3;
  margin-top: 1em;
}
</style>
